import Vue from "vue";
import VueMeta from 'vue-meta'
import App from "./App.vue";
import router from "./router";
import "./assets/style.scss";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationTriangle,faPhoneAlt,faForward } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faExclamationTriangle,faPhoneAlt,faForward)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false;


Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
